import type {
  B2bGateOrderResource,
  B2bGateSupplierOrderResource,
} from "@exonn/js-sdk";

export const mapResourceToRow = (
  resource: B2bGateOrderResource | B2bGateSupplierOrderResource,
) => {
  if ("order_number" in resource) {
    return {
      id: resource.id,
      path: [resource.id],
      status: "",
      created_at: resource.created_at,
      order_number: resource.order_number,
      total_price: resource.total_price,
      total_gross_price: resource.total_gross_price,
      supplier: "",
      is_blocked: resource.is_blocked,
      is_child: false,
      descendants_count: resource.descendants_count,
      shipping_service_provider: "",
      tracking_number: "",
    };
  }
  return {
    id: resource.id,
    path: [resource.b2b_gate_order_id, resource.id],
    status: resource.status,
    created_at: "",
    order_number: "",
    is_blocked: false,
    is_child: true,
    total_price: resource.total_price,
    total_gross_price: resource.total_gross_price,
    supplier: resource.supplier!.name || "",
    descendants_count: 0,
    shipping_service_provider: resource.shipping_service_provider,
    tracking_number: resource.tracking_number,
  };
};
